import api from "api";
import ApiCaller from "api/apiCaller";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Col,
  Row,
  Container,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import DataPipelineTemplate from 'model/data_pipeline_template';
import "./index.css";

interface CreatePipelineSelectionModalType {
  isShow: boolean;
  onModalClose?: Function;
}

const CreatePipelineSelectionModal = ({ isShow, onModalClose }:CreatePipelineSelectionModalType) => {
  const [modal, setModal] = useState(isShow || false);
  const [dataPipelineTemplates, setDataPipelineTemplates] = useState([]);
  const toggle = () => {
    setModal(!modal);
  }
  const goToTarget = (template:DataPipelineTemplate) => {
    window.location.href = `/data_pipeline/create/1?data_pipeline_template_id=${template.id}`;
  };
  const getDataPipelineTemplates = async () => {
    const res:any = await ApiCaller.get('pipeline/templates');
    if (res.data && res.data.data_pipeline_templates) {
      setDataPipelineTemplates(res.data.data_pipeline_templates);
    }
  };
  useEffect(() => {
    if (!modal && onModalClose) {
      onModalClose();
    }
  }, [modal]);
  useEffect(() => {
    getDataPipelineTemplates();
  }, []);
  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Select a data pipeline type</ModalHeader>
      <ModalBody>
        <Row>
          {dataPipelineTemplates.map((template:DataPipelineTemplate) =>
            <Col key={template.id} xs={12} sm={4}>
              <button
                className="data-pipeline-create-modal__type-select-button"
                onClick={() => goToTarget(template)}
              >
                {template.template_display_name}
              </button>
            </Col>
          )}
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Continue</Button>{' '}
        <Button color="secondary" onClick={toggle}>Go back</Button>
      </ModalFooter>
    </Modal>
  );
}

export default CreatePipelineSelectionModal;